import React from 'react';
import { Link } from 'react-router-dom';

const Header: React.FC = () => {
  return (
    <header className="header">
      <div className="header-inner">
        <Link to="/" className="logo">
          <div className="logo-mark">SCA</div>
          <span className="logo-text">Somali Copyright Agency</span>
        </Link>
        <nav className="header-nav">
          <Link to="/">Home</Link>
          <Link to="/about">About</Link>
          <Link to="/contact" className="btn-contact">
            Contact Us <span className="btn-arrow">&rarr;</span>
          </Link>
        </nav>
      </div>
    </header>
  );
};

export default Header;
